import { ReasonFormType } from 'components/reasons/ReasonForm';

export const createReasonInitialValues: Partial<ReasonFormType> = {
  isActive: true
};
